/**
 * Leerdepot-Quellen (EPIC I) — Avis-/Freistellungsprüfung an See-/Inland-Leerdepots. Eigene Domäne
 * neben Carrier-/Terminal-Quellen: KEIN Segellisten-/ContainerStatus-Bezug, sondern „ist dieser
 * Leercontainer am gewählten Depot angemeldet/verfügbar?". Browserbasierte Depots (z. B. HGK/NESKA,
 * Oracle APEX) laufen im Worker (Playwright) → die API delegiert via BullMQ (wie Browser-Terminals).
 */
/** Bekannte Leerdepots mit Avis-Prüfung (erweiterbar je neuem Depot-Adapter). */
export const EMPTY_DEPOTS = [
    // ── Welle 1 (I2): HGK/NESKA — browserbasiert (Oracle APEX, Login+MFA) ─────────────────
    {
        id: 'hgk_depot:CTS',
        name: 'HGK CTS (Köln)',
        location: 'Köln',
        platform: 'hgk_depot',
        locationCode: 'CTS',
    },
    {
        id: 'hgk_depot:DCH',
        name: 'HGK DCH (Düsseldorf)',
        location: 'Düsseldorf',
        platform: 'hgk_depot',
        locationCode: 'DCH',
    },
    {
        id: 'hgk_depot:RRT',
        name: 'HGK RRT (Duisburg)',
        location: 'Duisburg',
        platform: 'hgk_depot',
        locationCode: 'RRT',
    },
    // ── Welle 2 (I2b): Modality-Familie — öffentliche Formular-POSTs, kein Login ─────────
    {
        id: 'modality_classic:DECETE',
        name: 'DeCeTe (Duisburg)',
        location: 'Duisburg',
        platform: 'modality_classic',
        locationCode: 'DECETE',
        integrationType: 'scrape',
    },
    {
        id: 'modality_classic:IGS_HN',
        name: 'IGS (Heilbronn)',
        location: 'Heilbronn',
        platform: 'modality_classic',
        locationCode: 'IGS_HN',
        requiresReference: true,
        integrationType: 'scrape',
    },
    {
        id: 'modality_classic:IGS_MUC',
        name: 'IGS (München)',
        location: 'München',
        platform: 'modality_classic',
        locationCode: 'IGS_MUC',
        requiresReference: true,
        integrationType: 'scrape',
    },
    {
        id: 'modality_classic:IGS_NUE',
        name: 'IGS CDN (Nürnberg)',
        location: 'Nürnberg',
        platform: 'modality_classic',
        locationCode: 'IGS_NUE',
        requiresReference: true,
        integrationType: 'scrape',
    },
    {
        id: 'modality_classic:IGS_REG',
        name: 'IGS (Regensburg)',
        location: 'Regensburg',
        platform: 'modality_classic',
        locationCode: 'IGS_REG',
        requiresReference: true,
        integrationType: 'scrape',
    },
    {
        id: 'modality_classic:IGS_SW',
        name: 'IGS (Schweinfurt)',
        location: 'Schweinfurt',
        platform: 'modality_classic',
        locationCode: 'IGS_SW',
        requiresReference: true,
        integrationType: 'scrape',
    },
    {
        id: 'modality_classic:CTD',
        name: 'CTD (Dortmund)',
        location: 'Dortmund',
        platform: 'modality_classic',
        locationCode: 'CTD',
        integrationType: 'scrape',
    },
    {
        id: 'modality_modern:D3T',
        name: 'D3T (Duisburg)',
        location: 'Duisburg',
        platform: 'modality_modern',
        locationCode: 'D3T',
        requiresReference: true,
        integrationType: 'scrape',
    },
    {
        id: 'modality_modern:HSL_KEHL',
        name: 'HSL/ETK (Kehl)',
        location: 'Kehl',
        platform: 'modality_modern',
        locationCode: 'HSL_KEHL',
        integrationType: 'scrape',
    },
    {
        id: 'modality_modern:HSL_AND',
        name: 'HSL/ETK (Andernach)',
        location: 'Andernach',
        platform: 'modality_modern',
        locationCode: 'HSL_AND',
        integrationType: 'scrape',
    },
    // ── Welle 2 (I2b): HCS Hamburg (ASP.NET WebForms) + DBI/DB (IntraWeb, alle Standorte) ─
    {
        id: 'hcs_depot:HAM',
        name: 'HCS (Hamburg)',
        location: 'Hamburg',
        platform: 'hcs_depot',
        locationCode: 'HAM',
        requiresReference: true,
        integrationType: 'scrape',
    },
    {
        id: 'dbi_depot:ALL',
        name: 'DBI/DB (alle Standorte)',
        location: 'bundesweit',
        platform: 'dbi_depot',
        locationCode: 'ALL',
        integrationType: 'scrape',
    },
    // ── Welle 3 (I2c): MedRepair/MSC — Login (Blazor/Playwright), sucht per Referenz ─────
    ...[
        ['LEHAVRE', 'MedRepair (Le Havre)', 'Le Havre'],
        ['ROT_SMIRNOFF', 'MedRepair Smirnoffweg (Rotterdam)', 'Rotterdam'],
        ['ROT_BARGE', 'MedRepair Barge (Rotterdam)', 'Rotterdam'],
        ['ROT_WAALHAVEN', 'MedRepair Waalhaven (Rotterdam)', 'Rotterdam'],
        ['GERMANY', 'MedRepair Germany', 'Deutschland'],
        ['S11', 'MedRepair S11', 'Antwerpen'],
        ['POLAND', 'MEDLOG Poland', 'Polen'],
    ].map(([locationCode, name, location]) => ({
        id: `medrepair_depot:${locationCode}`,
        name,
        location,
        platform: 'medrepair_depot',
        locationCode,
        requiresReference: true,
        integrationType: 'login_headless',
    })),
    // ── Welle 3 (I2c): Contargo ERIS (Aggregator; Login liegt vor, A-124) + RET Straßburg ─
    {
        id: 'contargo_eris:ALL',
        name: 'Contargo ERIS (alle Standorte)',
        location: 'Contargo-Netz',
        platform: 'contargo_eris',
        locationCode: 'ALL',
        integrationType: 'login_headless',
    },
    {
        id: 'ret_etis:RET_NORD',
        name: 'RET Terminal Nord (Straßburg)',
        location: 'Straßburg',
        platform: 'ret_etis',
        locationCode: 'RET_NORD',
        integrationType: 'scrape',
    },
    {
        id: 'ret_etis:RET_SUD',
        name: 'RET Terminal Sud (Straßburg)',
        location: 'Straßburg',
        platform: 'ret_etis',
        locationCode: 'RET_SUD',
        integrationType: 'scrape',
    },
    {
        id: 'ret_etis:RET_R3FLEX',
        name: 'RET R3FLEX (Lauterbourg)',
        location: 'Lauterbourg',
        platform: 'ret_etis',
        locationCode: 'RET_R3FLEX',
        integrationType: 'scrape',
    },
    // ── Welle 3 (I2c): Login-Skelette — wählbar; ohne Credentials „Zugangsdaten nicht konfiguriert" ─
    ...[
        ['ktl_depot', 'KTL', 'KTL Onlineportal', 'Ludwigshafen'],
        ['dpw_str_depot', 'STR', 'DP World (Stuttgart)', 'Stuttgart'],
        ['tricon_depot', 'NUE', 'Tricon (Nürnberg)', 'Nürnberg'],
        ['ultrabrag_depot', 'BSL', 'Ultra-Brag (Basel)', 'Basel'],
        ['pcc_depot', 'ALL', 'PCC Intermodal', 'Polen'],
        ['tcsi_depot', 'LYON', 'TCSI (Lyon)', 'Lyon'],
        ['swissterminal_depot', 'CH', 'Swissterminal', 'Schweiz'],
    ].map(([platform, locationCode, name, location]) => ({
        id: `${platform}:${locationCode}`,
        name,
        location,
        platform,
        locationCode,
        integrationType: 'login_headless',
    })),
    // ── Welle 3 (I2c): keine (nutzbare) Online-Auskunft → „nicht prüfbar" (Recon 2026-07-05) ─
    {
        id: 'none:FRANKENBACH',
        name: 'Frankenbach (Mainz)',
        location: 'Mainz',
        platform: 'none',
        locationCode: 'FRANKENBACH',
        integrationType: 'none',
    },
    {
        id: 'none:KLOIBER',
        name: 'Kloiber (München)',
        location: 'München',
        platform: 'none',
        locationCode: 'KLOIBER',
        integrationType: 'none',
    },
];
/** Leerdepot per ID („<platform>:<locationCode>") auflösen. */
export function findDepot(id) {
    return EMPTY_DEPOTS.find((d) => d.id === id);
}
/** Mappt das Adapter-Ergebnis auf den UI-Ausgang (grün/rot/Fehler). */
export function depotOutcomeFromResult(result) {
    if (result.status === 'error')
        return 'error';
    if (result.status === 'not_found')
        return 'not_found';
    return result.available ? 'available' : 'not_available';
}
//# sourceMappingURL=depots.js.map